module.exports = __webpack_public_path__ + "static/media/21_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_02.541bec8c.jpg";